export default {
  install: function install(Vue, options) {
    Vue.prototype.$toProjectDetail = function (workId) {
      this.$router.push({
        path: "/community/projectDetail?workId=".concat(workId)
      });
    };
    Vue.prototype.$toUserDetail = function (userId) {
      this.$router.push({
        path: "/community/friends?userId=".concat(userId)
      });
    };
    Vue.prototype.$toGoodDetail = function (actionId) {
      this.$router.push({
        path: "/courseShop/goodsDetail?actId=".concat(actionId)
      });
    };
    Vue.prototype.$getMobileLink = function (workId) {
      return window.location.protocol + "//" + window.location.host + "/scratch3/scratch-mobile.html?workId=" + workId;
    };
  }
};